
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/sign-up",
      function () {
        return require("private-next-pages/company/sign-up.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/sign-up"])
      });
    }
  